import { WrapMdMarginBottom } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { ContactMeButton } from "Components/Form/ContactMeButton/ContactMeButton";
import { RetryPriceCheckButton } from "Components/PriceCheckFailedMessage/styled";
import { useTexts } from "Components/TextContext";
import {
  CAR_ABOUT_STEP,
  CAR_FIND_STEP,
} from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car";
import { CarProductDetailsFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductDetails/FormElements/interfaces";
import { CarProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductIntro/FormElements/interfaces";
import { mapFormToPriceRequest } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/utils/mapFormToPriceRequest";
import { CarPriceRequestInfo } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Car";
import { useFormState } from "Store/priceCalculation/priceCalculationHooks";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import ReactMarkdown from "react-markdown";

interface Props {
  isLoading: boolean;
  readonly updatePriceRequest: (
    payload: CarPriceRequestInfo,
    stepForwardOnSuccess?: boolean,
  ) => void;
}

export const FailedPriceCheckMessage = ({
  isLoading,
  updatePriceRequest,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const retryPriceRequest = useRetryPriceRequest(updatePriceRequest);

  const contactMeToggle = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1881_CONTACT_ME,
  );
  return (
    <>
      <WrapMdMarginBottom>
        <ContactUsAlert title={getText("checkprice.pricecheckfailed.title")}>
          <ReactMarkdown>
            {getText("alertdescription.pricecheckfailed")}
          </ReactMarkdown>
          {contactMeToggle && <ContactMeButton />}
          <RetryPriceCheckButton
            onClick={retryPriceRequest}
            loading={isLoading}
            trackId={"retry-price-check-button"}
          >
            {getText("checkprice.pricecheckfailed.button")}
          </RetryPriceCheckButton>
        </ContactUsAlert>
      </WrapMdMarginBottom>
    </>
  );
};

const useRetryPriceRequest = (
  updatePriceRequest: Props["updatePriceRequest"],
): (() => void) => {
  const userIdentification = useUserIdentificationSelector();
  const introFormValues = useFormState(
    CAR_FIND_STEP.id,
  ) as Required<CarProductIntroFormValues>;
  const detailsFormValues = useFormState(
    CAR_ABOUT_STEP.id,
  ) as CarProductDetailsFormValues;

  return (): void => {
    updatePriceRequest(
      mapFormToPriceRequest(
        userIdentification,
        introFormValues,
        detailsFormValues,
      ),
      false,
    );
  };
};
